import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Delete Comapany Master'}
      url={'company-master'}
      queryKey="company-master"
      title={'Comapany Master'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
